const locale = 'en';

const antd = {
  locale,
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    loading: 'Loading'
  },
  Calendar: {
    markItems: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    renderYearAndMonth: (year: any, month: any) => `${year}/${month}`
  },
  Cascader: {
    placeholder: 'Select'
  },
  Dialog: {
    ok: 'OK'
  },
  ErrorBlock: {
    default: {
      title: 'Something went wrong',
      description: ''
    },
    busy: {
      title: 'Failed to load data',
      description: ''
    },
    disconnected: {
      title: '',
      description: ''
    },
    empty: {
      title: '',
      description: ''
    }
  },
  Form: {
    required: 'Required field',
    optional: 'Optional',
    defaultValidateMessages: {
      default: 'Invalid value in ${label}',
      required: '${label} is required',
      enum: '${label} must be one of ${enum}',
      whitespace: '${label} cannot be empty',
      date: {
        format: '${label} date format is invalid',
        parse: '${label} cannot be converted to a date',
        invalid: '${label} is an invalid date'
      },
      types: {
        string: '${label} is not a valid ${type}',
        method: '${label} is not a valid ${type}',
        array: '${label} is not a valid ${type}',
        object: '${label} is not a valid ${type}',
        number: '${label} is not a valid ${type}',
        date: '${label} is not a valid ${type}',
        boolean: '${label} is not a valid ${type}',
        integer: '${label} is not a valid ${type}',
        float: '${label} is not a valid ${type}',
        regexp: '${label} is not a valid ${type}',
        email: '${label} is not a valid ${type}',
        url: '${label} is not a valid ${type}',
        hex: '${label} is not a valid ${type}'
      },
      string: {
        len: 'Length of ${label} must be ${len} characters',
        min: 'Length of ${label} must be at least ${len} characters',
        max: 'Length of ${label} must be at most ${len} characters',
        range: 'Length of ${label} must be between ${len} and ${max} characters'
      },
      number: {
        len: '${label} must be equal to ${len}',
        min: '${label} must be at least ${min}',
        max: '${label} must be at most ${max}',
        range: '${label} must be between ${min}-${max}'
      },
      array: {
        len: 'Must be ${len} ${label}',
        min: 'At least ${min} ${label}',
        max: 'At most ${max} ${label}',
        range: 'The amount of ${label} must be between ${min}-${max}'
      },
      pattern: {
        mismatch: '${label} does not match the pattern ${pattern}'
      }
    }
  },
  ImageUploader: {
    uploading: 'Uploading...',
    upload: 'Upload'
  },
  InfiniteScroll: {
    noMore: 'No more',
    failedToLoad: 'Failed to load',
    retry: 'Retry'
  },
  Mask: {
    name: 'Mask'
  },
  Modal: {
    ok: 'OK'
  },
  PullToRefresh: {
    pulling: 'Pull down to refresh',
    canRelease: 'Release to refresh immediately',
    complete: 'Refresh successful'
  },
  Slider: {
    name: 'Slider'
  },
  Stepper: {
    decrease: 'Decrease',
    increase: 'Increase'
  },
  Switch: {
    name: 'Switch'
  }
};

export const en = {
  antd,
  locale,
  common: {
    download: 'Download',
    cancel: 'Cancel',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    general: 'General',
    search: 'Search',
    sex: 'Sex',
    sexName: {
      MALE: 'Male',
      FEMALE: 'Female',
      NOT_SPECIFIED: 'Not specified',
      OTHER: 'Other'
    },
    minutesShort: 'min.',
    ehr: 'Medical record',
    birthday: 'Birthday',
    phoneNumber: 'Phone number',
    email: 'Email',
    appointmentInfo: 'Appointment info',
    info: 'Info',
    mainInfo: 'Main information',
    additionalInfo: 'Additional information',
    saveChanges: 'Save changes'
  },
  auth: {
    title: 'Doctor Cabinet',
    formTitle: 'Authorization',
    login: 'Login',
    password: 'Password',
    loginButton: 'Log in',
    logoutButton: 'Log out'
  },
  nav: {
    profile: 'Profile',
    clients: 'Clients',
    appointments: 'Appointments',
  },
  appointment: {
    myProgress: 'My progress',
    comment: 'Appointment feedback',
    noNotes: 'No comment provided',
    noAddress: 'Address not provided',
    list: 'Appointments',
    selectResourceError: 'Select a specific resource',
    allResources: 'All resources',
    partialLoadWarning: 'Partial load was interrupted for businesses:',
    info: 'Appointment details',
    cancelQuestion: 'Cancel this appointment?',
    cancelled: 'Appointment was cancelled',
    completed: 'Appointment completed',
    duration: 'Duration'
  },
  client: {
    info: 'Client information',
    list: 'Clients',
    id: 'Client ID',
    noBirthday: 'Birthday not provided',
    noEmail: 'Email not provided',
    noPhone: 'Phone number not provided'
  },
  dates: {
    months: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ],
    weekdays: [
      'Monday', 'Tuesday', 'Wednesday', 'Thursday',
      'Friday', 'Saturday', 'Sunday'
    ],
    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  inputs: {
    textPlaceholder: 'Enter text',
    datePlaceholder: 'Specify date',
    filePlaceholder: 'No file',
    dropdownPlaceholder: 'Not selected',
    dropdownNoElements: 'No results',
  },
  customStep: {
    textChangeSlot: 'Do you really want to swap these time slots?',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
}
